import React from 'react'
import Text from '../../../Text'
import styles from './styles.module.css'
import CountriesAutocomplete from '../../../MyAutocomplete/CountriesAutocomplete'
import { $error, $textPrimary } from '../../../../styles/colors/semantics'
import LocationIconFilled from '../../../icons/LocationIconFilled'

function ShippingInfoSection(props) {
  const { countries = [], selectedCountryCode, shippingInfo, isLoading } = props

  const shipsFromInfo = shippingInfo && shippingInfo.shipsFrom ? shippingInfo.shipsFrom : ''

  const renderShippingInfoText = () => {
    return <div className={styles.shippingInfoText}>
      <Text type="tiny">SHIP{shipsFromInfo && shipsFromInfo !== 'null' ? ' from ' + shipsFromInfo : ''} TO</Text>
    </div>
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <div className={styles.locationWrapper}>
          <div className={styles.icon}>
            <LocationIconFilled />
          </div>
          <div className={styles.shipToWrapper}>
            { renderShippingInfoText() }
            <div className={styles.autocompleteWrapper}>
              {/* CLS genuine-0: a STATIC font (the former useDetectMobile(991) JS
                  flip -5/-2 is now a CSS media query in
                  MyAutocomplete/styles.module.css, so the mobile 11px paints on the
                  first paint) + a fixed-width reserved box (staticWidth) so the
                  ship-to picker's box (and its right-anchored dropdown arrow) never
                  reflows post-hydration -> the last ~0.0009 of /us/shop CLS -> 0. */}
              <CountriesAutocomplete
                countries={countries}
                selectedCountryCode={selectedCountryCode}
                inputTextColor={$textPrimary.dark}
                popupIndicatorColor={$textPrimary.dark}
                transparentBorder
                isUpperCase={true}
                fontSizeAdjust={-2}
                staticWidth
                dark
                maxWidth
              />
            </div>
          </div>
        </div>
        {/* NOTE: Commented out due to layout change */}
        {/*<div className={`${styles.transitTimesWrapper} ${!isLoading ? styles.transitTimesWrapperVisible : ''}`}>*/}
          {/*{ renderNotices(state.shippingInfo, state.shopItems) }*/}
        {/*</div>*/}
      </div>
    </div>
  )
}

const renderNotices = (shippingInfo, shopItems) => {
  if (!shippingInfo || !shippingInfo.transitTimeDays) {
    return <>

      <div className={styles.notice}>
      <Text type="small"
            highlight={'*'}
            highlightSx={`color: ${$error}; font-weight: 500;`}
            color={$textPrimary.dark}
      >Sorry, we are currently not shipping to your location</Text>
    </div>
      </>
  }

  const isTaxIncluded = shopItems && shopItems.length && shopItems[0].taxIncluded

  return (
    <>
      {isTaxIncluded && <div className={`${styles.verticalLine} ${styles.verticalLineHiddenXLarge}`}/>}
      {
        isTaxIncluded && <div className={styles.notice}>
          <Text type="tiny">Prices:</Text>
          <Text type="heading-10" color={$textPrimary.dark}>Include {shopItems[0].taxIncluded}</Text>
        </div>
      }
      <div className={`${styles.verticalLine}${!isTaxIncluded ? ' ' + styles.verticalLineHiddenXLarge : ''}`}/>
      {
        shippingInfo.processingTimeDays && <div className={styles.notice}>
          <Text type="tiny">Processing times:</Text>
          <Text type="heading-10" color={$textPrimary.dark}>{shippingInfo.processingTimeDays} business days</Text>
          <div className={styles.preOrderWarning}>
            <Text type="tiny" color={$textPrimary.dark}>Does not apply to pre-orders</Text>
          </div>
        </div>
      }
      <div className={styles.verticalLine}/>
      {
        shippingInfo.transitTimeDays && <div className={styles.notice}>
          <Text type="tiny">Transit times:</Text>
          <Text type="heading-10" color={$textPrimary.dark}>{shippingInfo.transitTimeDays} business days</Text>
        </div>
      }
      <div className={`${styles.verticalLine} ${styles.verticalLineHiddenXLarge}`}/>
    </>
  )
}

export default ShippingInfoSection
